// extracted by mini-css-extract-plugin
module.exports = {"roundedCorners":"tiltable-container-module--rounded-corners--6oDF9"};